import * as Html from "../../util/Html.ts";
import Icons from "../../svg/Icons.ts";
export {init,smoothScrollTo}
Html.registerWidget('widget/specific/carrousel',{init:init})


function smoothScrollTo(container,targetIdx){
  clearInterval(container.getAttribute('smoothScrollInterval'));
  
  let
    length = container.childNodes.length,
    idx = (targetIdx + 50*length) % length,
    scrollTarget = idx * container.offsetWidth,
    scrollBegin = container.scrollLeft,
    frame=0,
    subInterval = setInterval(function(){
      frame++;
      container.scrollTo(scrollBegin+(scrollTarget-scrollBegin)*frame/50,0);
      if(frame>=50){
        clearInterval(subInterval);
      }
    },10);
  container.setAttribute('smoothScrollInterval',subInterval)
}

function init(obj){

  obj.append('<icon class="picture-right">'+Icons.ic_chevron_right+'</icon>');
  obj.append('<icon class="picture-left">'+Icons.ic_chevron_left+'</icon>');

  let 
    nextTag = obj.find('.picture-right'),
    prevTag = obj.find('.picture-left'),
    imgContainer = obj.find('div'),
    length = imgContainer.children().length,
    subInterval,
    idx = 0;
  
  function moveTo(targetIdx){
    idx = (targetIdx +50*length) % length;
    smoothScrollTo(imgContainer.get(0),idx); 
    nextTag.toggle(idx<length-1);
    prevTag.toggle(idx>0);
    
  }
  moveTo(0);
  obj.attr('autoscroll',setInterval(function(){
    idx++;
    moveTo(idx);
  },4000));

  nextTag.on("click",function(e){
    e.stopPropagation();
    e.preventDefault();
    clearInterval(obj.attr('autoscroll'));
    moveTo(idx+1);
  });
  prevTag.on("click",function(e){
    e.stopPropagation();
    e.preventDefault();
    clearInterval(obj.attr('autoscroll'));
    moveTo(idx-1);
  });

  obj.swipe( {
    swipeRight:function(){
      if(idx>0){
        clearInterval(obj.attr('autoscroll'));
        moveTo(idx-1);
      }
    },
    swipeLeft:function(){
      if(idx<length){
        clearInterval(obj.attr('autoscroll'));
        moveTo(idx+1);
      }
    }
  });
  
}